import React from 'react';
import ImageThumb from './ImageThumb';

export default class ImageThumbList extends React.Component {
  constructor(props) {
    super(props);
  }

  onClick = (e) => {
    this.props.slideCarouselToIndexOnClick();
  }

  render() {
    return (
      <>
        {/* <div className='select_label'>
          Twoje obrazy:
        </div> */}
        <div className="flex-container" onClick={this.onClick}>
          {this.props.customerImageLayers !== undefined 
            && this.props.customerImageLayers.length > 0 
            && this.props.customerImageLayers.map((value, index) =>
              <ImageThumb
                key={this.props.stageId + '_' + index} 
                index={this.props.stageId + '_' + index} 
                layer={value}
                rerenderCustomizationInputs={this.props.rerenderCustomizationInputs}
                />                
          )}
        </div>
      </>
    )
  }
}